<div class="col-12 pt-0 " style="padding: 1rem;">
  <div class="card">
      <p-table
          #dt1
          [value]="listaProcessos"
          dataKey="id"
          [rows]="10"
          [rowHover]="true"
          [paginator]="true"
          responsiveLayout="scroll"
      >
          <ng-template pTemplate="header">
              <tr>
                  <th pSortableColumn="description">
                      {{ messageUtil.translateKey('DESCRIPTION') }} <p-sortIcon field="description"></p-sortIcon>
                  </th>

                  <th pSortableColumn="startDate">
                      {{ messageUtil.translateKey('START') }} <p-sortIcon field="startDate"></p-sortIcon>
                  </th>

                  <th pSortableColumn="endDate">
                      {{ messageUtil.translateKey('END') }}
                      <p-sortIcon field="endDate"></p-sortIcon>
                  </th>


                  <th pSortableColumn="use.firstName">
                    {{ messageUtil.translateKey('USER') }}
                    <p-sortIcon field="user.firstName"></p-sortIcon>
                </th>

                  <th class="text-center">
                      {{ messageUtil.translateKey('SUCCESS') }}
                  </th>

                  <th class="text-center">
                      {{ messageUtil.translateKey('DOWNLOAD') }}
                  </th>

              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-process>
              <tr>
                  <td>
                      {{ process.description }}
                  </td>
                                     <td>
                       {{ process.startDate | date: 'dd/MM/yyyy HH:mm:ss' }}
                   </td>
                   <td>
                       {{ process.endDate | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </td>
                  <td>
                    {{ process.user.firstName + ' ' + process.user.lastName }}
                </td>
                  <td class="text-center">
                      <i class="pi pi-check" *ngIf="process.success===true" style="color:green;"></i>
                      <i class="pi pi-spin pi-spinner" *ngIf="process.success===null"></i>
                      <i class="pi pi-times"  pTooltip={{process.errorDescription}} style="color:red;" *ngIf="process.success===false"></i>
                  </td>
                  <td>
                      <div class="flex justify-content-center">
                         <i class="pi pi-download" [style.color]="isLogFile(process.urlFile1) ? 'black' : '#199BF1'" style="cursor:pointer;" (click)="download(process.urlFile1, process)" *ngIf="shouldDisplayFile(process.urlFile1)"></i>
                         <i class="pi pi-download pl-2" [style.color]="isLogFile(process.urlFile2) ? 'black' : '#199BF1'" style="cursor:pointer;" (click)="download(process.urlFile2, process)" *ngIf="shouldDisplayFile(process.urlFile2)"></i>
                         <i class="pi pi-download pl-2" [style.color]="'black'" style="cursor:pointer;" pTooltip="Log texto" (click)="downloadLog(process)" *ngIf="showReturnImportLogShortcut(process) && shouldDisplayFile(process.urlFile1)"></i>
                      </div>
              </tr>
          </ng-template>
      </p-table>
      <div class="footer-message text-center" style="margin-top: 1rem;">
        <p>{{ messageUtil.translateKey('PAGE_AUTO_REFRESH') }}</p>
      </div>
  </div>
</div>
